<template>
  <page-loader v-if="loadingStatus == 'loading'" />
  <div v-else class="contain-section">
    <div class="row">
      <div class="col-sm-12">
        <div class="inner-box">
          <div class="banner-box">
            <img class="rounded-4 h-400 img-row-feedback"
              :src="history && history.main_image ? history.main_image[0].url : ''" alt="Logo" />
          </div>
          <div class="inner-content">
            <h3 class="d-flex align-items-center justify-content-center w-100 mb-0">
              {{ history ? history.heading : "" }}
            </h3>
            <div class="col-sm-12 mt-5 mb-5 highlight-text">
              <div class="row justify-content-center">
                <div class="col-sm-4">
                  <div class="hightlight-box parental-color">
                    <span>Your Haplogroup is</span>
                    <h4>{{ fatherlineStore.result.haplogroup }}</h4>
                  </div>
                </div>
                <div v-if="fatherlineStore.result.subclade" class="col-sm-4">
                  <div class="hightlight-box parental-color">
                    <span>Your haplotype is</span>
                    <h4>{{ fatherlineStore.result.subclade }}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="odd-even-section px-0">
            <div class="col-sm-12">
              <div class="row random-box odd">
                <div class="col-sm-12 col-md-12 col-lg-7 random-parg">
                  <p v-html="fatherlineStore.result.content.contentOne.body" />
                </div>
                <div class="col-sm-12 col-md-12 col-lg-5 rand-img">
                  <img :src="fatherlineStore.result.content.contentOne.image" alt="view" class="rounded-2 h-auto" />
                </div>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="row random-box even">
                <div class="col-sm-12 col-md-12 col-lg-5 rand-img">
                  <img :src="fatherlineStore.result.content.contentTwo.image" alt="view" class="rounded-2 h-auto" />
                </div>
                <div class="col-sm-12 col-md-12 col-lg-7 random-parg">
                  <p v-html="fatherlineStore.result.content.contentTwo.body" />
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <ul class="d-flex flex-column justify-content-start text-start w-100 fs-6 lh-2 text-dark gap-2 mt-5">
              <li v-for="citation in fatherlineStore.result.content.citations" :key="citation.id">
                <a v-if="citation.type === 'external_url'" :href="citation.source" class="text-dark fs-14">
                  {{ citation.title }}
                </a>
                <div v-else>{{ citation.title }}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import "../../../styles/pages/ancentry/recent-ancetry.scss";
import { useFatherlineStore } from "@/store/parentalStore";
import { getFatherlineHistory } from "@/services/fatherline";
import { ref, onMounted } from "vue";
const fatherlineStore = useFatherlineStore();
const loadingStatus = ref("loading");
const history = ref({});
onMounted(async () => {
  history.value = await getFatherlineHistory();
  loadingStatus.value = "loaded";
});
</script>
